import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

const MessagesPage = lazy(() =>
  import("@/admin/pages/MessagesPage").then((m) => ({ default: m.MessagesPage })),
);

export const Route = createFileRoute("/admin/messages")({
  component: () => (
    <Suspense fallback={null}>
      <MessagesPage />
    </Suspense>
  ),
});
